import { render, staticRenderFns } from "./GroupPricingDoseDistribuition.vue?vue&type=template&id=ffc492b0&"
import script from "./GroupPricingDoseDistribuition.vue?vue&type=script&lang=js&"
export * from "./GroupPricingDoseDistribuition.vue?vue&type=script&lang=js&"
import style0 from "./GroupPricingDoseDistribuition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports